import { FC } from "react";
import styles from "./OfferPreview.module.scss";
import { CustomButton } from "~/components/custom-button";
import cn from "classnames";
import { CheckboxField } from "~/components/checkbox-field";
import { GetTextOfferAccept } from "./GetTextOfferAccept";
import { sanitizeData } from '~/utils';

interface OfferContentProps {
	offerHtml: string;
	consentChecked: boolean;
	setConsentChecked: (checked: boolean) => void;
	isLoadingConfirmAgreement: boolean;
	handleAgree: () => void;
	handleEdit: () => void;
}

export const OfferContent: FC<OfferContentProps> = ({
	offerHtml,
	consentChecked,
	setConsentChecked,
	isLoadingConfirmAgreement,
	handleAgree,
	handleEdit,
}) => {
	return (
		<>
			<h3 className={styles.title}>ШАБЛОН УСЛОВИЯ ПУБЛИЧНОЙ ОФЕРТЫ</h3>
			<div className={`${styles.document} ym-hide-content`} dangerouslySetInnerHTML={{
				__html: sanitizeData(offerHtml, {
					USE_PROFILES: { html: true },
					WHOLE_DOCUMENT: true,
				})
			}} />
			<div className={styles.actions}>
				<div className={styles.checkboxLabel}>
					<CheckboxField
						fieldName="accept-offer"
						name={consentChecked}
						checked={consentChecked}
						title={<GetTextOfferAccept />}
						styleIndicatorProps={{ top: 4 }}
						onChange={(event: any) => setConsentChecked(event)}
					/>
				</div>
				<div className={styles.buttonGroup}>
					<CustomButton
						name="Нужно внести правки"
						type="button"
						className={cn(styles.buttonBack)}
						onClick={handleEdit}
						disabled={isLoadingConfirmAgreement}
					/>
					<CustomButton
						type="button"
						name="Согласен с офертой"
						className={cn(styles.buttonAgree)}
						onClick={handleAgree}
						disabled={!consentChecked || isLoadingConfirmAgreement}
						isLoading={isLoadingConfirmAgreement}
					/>
				</div>
			</div>
		</>
	);
};